<template>
  <div class="wrapper-template"
       id='sectionContainer'>

    <div class="inner-wrapper-one">
      <div class="wrapper-template__inner height-100">
        <div class="mode-side mode-side_left mode-side_left-flex-column">
          <div class="mode-side-text">
            <span class="mode-side-text__title" v-html="lang.startPageText.title"></span>
            <p class="mode-side-text__p mode-side-text__text-p">
              {{lang.startPageText.desc}}
            </p>
          </div> 
        </div>

        <div class="mode-side mode-side_right">
          <div v-if="isRU" class="start-page-img start-page-img_ru"></div>
          <div v-if="!isRU" class="start-page-img start-page-img_en"></div>
        </div>

      </div>
    </div>
    <img class="keyboard" src="../../../../public/assets/images/keyboard.png" alt="">

  </div>
</template>

<script>
import switchClasses from '@/util/switcherClasses.js'

export default {
  name: 'START_PAGE',

  props: {
    insults: Boolean
  },

  data() {
    return {
      lang: this.$root.$options.LANG.INDEX,
      isRU: this.$root.$options.LANG.lang === 'ru',
    }
  },

  created: function() {
    this.$emit('setNextRouteBtn', [{ optionPage:{page: 'about.html'} }]);
  },

  mounted: function() {
    this.$emit('visibleInsultEvent', [{visible: false}]);
    this.$emit('translateTextEventInner', ['step_two']);
    this.$emit('isNotFound', [{is: false}]);
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
 @import '01.scss';
</style>
